import { render, staticRenderFns } from "./LayoutLoader.vue?vue&type=template&id=b47eeb2a&scoped=true&"
import script from "./LayoutLoader.vue?vue&type=script&lang=js&"
export * from "./LayoutLoader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutLoader.vue?vue&type=style&index=0&id=b47eeb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47eeb2a",
  null
  
)

export default component.exports